import React, { useState } from "react";

import SettingsTutorial from "../SettingsTutorial";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";

import ImageProject from "../../../../assets/img/project_setsumei.webp";

import { useAppSelector } from "../../../../redux/hooks";
import { getLinkedPages } from "../../../../redux/reducers/user";
import { getAuthToken } from "../../../../redux/reducers/auth";

import { PageVisibility } from "../../../../utils/PageVisibility";
import {
  useGetProject,
  usePostProjectApproval,
  useUpdateProject,
} from "../../../../utils/useProject";

const ProjectSettingsContainer: React.FC = () => {
  // TODO page relationshipsからIDを指定してdispatchする処理を追加
  const auth_token = useAppSelector(getAuthToken);
  const linked_pages = useAppSelector(getLinkedPages);

  const queryArgs = {
    auth_token: auth_token,
    per: -1,
    id: linked_pages?.project ?? null,
  };

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const {
    items: { projects },
    isLoading: projectLoading,
  } = useGetProject(queryArgs, true);

  const { mutateAsync, mutateLoading } = useUpdateProject([
    "project",
    queryArgs,
  ]);

  const { requestAsync, requestLoading } = usePostProjectApproval([
    "project",
    queryArgs,
  ]);

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id?: string) => {
    if (auth_token && id) {
      await mutateAsync({
        auth_token,
        update: {
          sonic_id: id,
          sonic_status: PageVisibility.NotPubliclyVisible,
        },
      });
    }
  };

  const handlePublish = async (id?: string) => {
    if (auth_token && id) {
      await requestAsync({ auth_token: auth_token, id: id });
      setIsComplete(true);
    }
  };

  const tutorial = (
    <SettingsTutorial
      img_src={ImageProject}
      title="プロジェクトとは？"
      explanation="仕事や企画、イベントのメンバーなどの募集を掲載できます。応募後のユーザー間のやりとりはSELeCTがサポートするので安心です。"
    />
  );

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        backBarText="プロジェクト設定"
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (projectLoading || mutateLoading || requestLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <Settings
        type="プロジェクト"
        description="プロジェクトを作成してeスポーツ事業に関わるメンバーを集めよう!!"
        link="/mypage/project/settings/create"
        tutorial={tutorial}
        currentMenu={currentMenu}
      >
        {projects.length > 0
          ? projects.map((el, i) => (
              <SettingsItem
                key={i}
                page_type={"プロジェクト"}
                id={el.id}
                img_src={el?.imgs?.[0]?.thumbnail?.url}
                name={el.name}
                type={el.type}
                applicants={el.applicants}
                start_date={el.start_date}
                end_date={el.end_date}
                status={el.status}
                handleMenu={() =>
                  setCurrentMenu(i === currentMenu ? undefined : i)
                }
                handlePublish={handlePublish}
                handlePrivate={handlePrivate}
                edit_link={`/mypage/project/settings/${el.id}`}
                detail_link={`/project/${el.id}`}
                isMenuOpen={currentMenu === i ? true : false}
                isOwner={true}
                borderColorStyle={`#f79b00`}
                typeTagStyle={el.type?.color}
              />
            ))
          : null}
      </Settings>
    );
  }
};

export default ProjectSettingsContainer;
